import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "mask"
})
export class MaskPipe implements PipeTransform {
  transform(value: any, digitsToMask:number, valueToReplace:string): any {
    if(value){
      const visibleDigits = digitsToMask;
      value=value.toString();
      let maskedSection = value.slice(0, -visibleDigits);
      let visibleSection = value.slice(-visibleDigits);
      return maskedSection.replace(/./g, valueToReplace) + visibleSection;
    } else{
      return value;
    }
  }
}
